import React from 'react'
import axios from 'axios'
import { Typography, TextField, Button, Grid, Chip } from '@material-ui/core'

const cardStyle = {
  backgroundColor: '#fff', borderRadius: 8,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: 16, marginBottom: 16
}

const ROLE_LABELS = {
  sales_bizdev: 'Sales / BizDev', primary_contact: 'Primary Contact',
  precon_manager: 'Precon Manager', lead_estimator: 'Lead Estimator',
  permitting_lead: 'Permitting Lead', procurement_lead: 'Procurement Lead'
}

const AspireHandoffCard = ({ projectId, project, aspireHandoff, url, onUpdate }) => {
  const ah = aspireHandoff || {}
  const [jobNumber, setJobNumber] = React.useState(ah.aspireJobNumber || '')
  const [propertyId, setPropertyId] = React.useState(ah.aspirePropertyId || '')
  const [handoffNotes, setHandoffNotes] = React.useState(ah.handoffNotes || '')
  const [saving, setSaving] = React.useState(false)
  const [completing, setCompleting] = React.useState(false)

  const isCompleted = !!ah.handoffCompletedAt

  const handleSave = () => {
    setSaving(true)
    axios.put(`${url}/api/bid-estimation/projects/${projectId}/post-close`, {
      aspireHandoff: { aspireJobNumber: jobNumber, aspirePropertyId: propertyId, handoffNotes }
    }).then(res => { setSaving(false); onUpdate(res.data) })
      .catch(err => { console.error(err); setSaving(false) })
  }

  const handleComplete = () => {
    setCompleting(true)
    axios.post(`${url}/api/bid-estimation/projects/${projectId}/post-close/aspire-handoff/complete`)
      .then(res => { setCompleting(false); onUpdate(res.data) })
      .catch(err => { console.error(err); setCompleting(false) })
  }

  return (
    <div style={cardStyle}>
      <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 12 }}>Aspire Handoff</Typography>

      {/* Project data panel (read-only copy reference) */}
      <div style={{ backgroundColor: '#f5f5f5', borderRadius: 6, padding: 12, marginBottom: 12 }}>
        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Project Data (for Aspire entry)</Typography>
        <Grid container spacing={1} style={{ marginTop: 4 }}>
          <Grid item xs={6}><Typography variant="body2" style={{ fontSize: 12 }}>Name: {project?.name || '—'}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" style={{ fontSize: 12 }}>Client: {project?.client || '—'}</Typography></Grid>
          <Grid item xs={6}>
            <Typography variant="body2" style={{ fontSize: 12 }}>
              Won: {project?.followUp?.wonAt ? new Date(project.followUp.wonAt).toLocaleDateString() : '—'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" style={{ fontSize: 12 }}>
              Due: {project?.bidDueDate ? new Date(project.bidDueDate).toLocaleDateString() : '—'}
            </Typography>
          </Grid>
          {(project?.roles || []).filter(r => r.userName).map(r => (
            <Grid item xs={6} key={r.role}>
              <Typography variant="body2" style={{ fontSize: 11 }}>
                {ROLE_LABELS[r.role] || r.role}: {r.userName}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </div>

      {/* Handoff tracking */}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField fullWidth size="small" variant="outlined" label="Aspire Job Number"
            value={jobNumber} onChange={e => setJobNumber(e.target.value)} />
        </Grid>
        <Grid item xs={6}>
          <TextField fullWidth size="small" variant="outlined" label="Aspire Property ID"
            value={propertyId} onChange={e => setPropertyId(e.target.value)} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth size="small" variant="outlined" label="Handoff Notes" multiline rows={3}
            value={handoffNotes} onChange={e => setHandoffNotes(e.target.value)}
            inputProps={{ maxLength: 2000 }} />
        </Grid>
      </Grid>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
        <div>
          {isCompleted ? (
            <Chip size="small" label={`Handoff Complete — ${new Date(ah.handoffCompletedAt).toLocaleDateString()}`}
              style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', fontSize: 11 }} />
          ) : (
            <Button size="small" variant="outlined" onClick={handleComplete} disabled={completing}
              style={{ textTransform: 'none', fontSize: 12, borderColor: '#2e7d32', color: '#2e7d32' }}>
              {completing ? 'Completing...' : 'Mark Handoff Complete'}
            </Button>
          )}
        </div>
        <Button size="small" variant="contained" color="primary" onClick={handleSave} disabled={saving}
          style={{ textTransform: 'none', fontSize: 12 }}>
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </div>
    </div>
  )
}

export default AspireHandoffCard
